import { render } from "./PhotoThumbnail.vue?vue&type=template&id=465fb003&ts=true"
import script from "./PhotoThumbnail.vue?vue&type=script&lang=ts"
export * from "./PhotoThumbnail.vue?vue&type=script&lang=ts"

import "./PhotoThumbnail.vue?vue&type=style&index=0&id=465fb003&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__